module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sidebar d-flex align-items-end relative alt"
  }, [_c('img', {
    staticClass: "smallLogo",
    attrs: {
      "src": "/static/images/common/logo_small_red_white.svg"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": "/static/images/auth/signup.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [(_vm.typeSentence) ? _c('div', {
    staticClass: "fs-small dark"
  }, [_vm._v(_vm._s(_vm.typeSentence))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "fs-largest lightest headline"
  }, [_vm._v("\"We can turn our effort into creating better experiences to our customers.\"")]), _vm._v(" "), _c('div', {
    staticClass: "fs-small dark"
  }, [_vm._v("No booking fees for unlimited products and unlimited agents.")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b4d39ad"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/auth/sidebars/SignupSidebar.vue
// module id = 1162
// module chunks = 0